module.exports = __webpack_public_path__ + "img/guru.89abf7a6.png";